import { RegularPayments } from './_models/payments';

export interface Tariff {
  name?: string;
  recommended_balance?: number;
  service_id?: number;
  id?: string;
  is_default: boolean;
  should_penalty_trip_cancel?: boolean; // - включить / выключить штраф за отмену поездки
  penalty_trip_cancel_value?: number; // - штраф за отмену поездки(число от 0 до 100)
  penalty_trip_cancel_type?: PaymentTypes; // - тип значения за отмену поездки(natural - фиксированная сумма, percent - проценты)
  should_penalty_offer_reject?: boolean; // - включить / выключить штраф за отклонение предложения
  penalty_offer_reject_value?: number; // -
  penalty_offer_reject_type?: PaymentTypes; // -
  should_penalty_offer_cancel?: boolean; // - включить / выключить штраф за отмену предложения по таймауту
  penalty_offer_cancel_value?: number; // -
  penalty_offer_cancel_type?: PaymentTypes; // -
  should_penalty_card_payment_trip_cancel?: boolean; // - включить отдельную комиссию для безналичных заказов
  penalty_card_payment_trip_cancel_value?: number; // - значение комиссии
  penalty_card_payment_trip_cancel_type?: PaymentTypes;
  is_commission_enabled?: boolean; // - включить / выключить комиссию за выполнение заказа
  commission_value?: number; // - значение комиссии(число от 0 до 100)
  commission_type?: PaymentTypes; // - тип значения комисии(natural - фиксированная сумма, percent - проценты)
  is_commission_offer_enabled?: boolean; // - включить / выключить комиссию за выполнение заказа из раздачи
  commission_offer_value?: number; // -
  commission_offer_type?: PaymentTypes; // -
  use_bonus_value?: boolean; // - включить / выключить доплату за заказ из штрафов
  bonus_value?: number; // - значение доплаты за заказ(из эфира)(процентов)
  bonus_offer_value?: number; // - значение доплаты за заказ(из предложения)(процентов)
  should_block_ether?: boolean; // - включить / выключить блокировку эфира по балансу
  ether_min_balance?: number; // - минимальный баланс для блокировки эфира
  is_commission_intercity_enabled?: boolean;
  commission_intercity_value?: number;
  commission_intercity_type?: PaymentTypes;
  debt_limit: number;
  regular_payments?: RegularPayments[];
  commission_scale_value_type: 'base' | 'sending';
  commission_scale_type: 'last_week' | 'current_week';
  commission_scale_request_type: 'all' | 'sending';
  commission_scale_request_visibility: 'all' | 'visible' | 'hidden';
  commissions?: Commission[];
  is_commission_hidden_mode_enabled?: boolean; //  - включить комиссию за выполнение заказа в закрытом режиме
  commission_hidden_mode_type?: PaymentTypes; // тип комиссии
  commission_hidden_mode_value?: number; // - значение комиссии
  is_commission_hidden_mode_sending_enabled?: boolean; // - включить комиссию за выполнение магнитного заказа в закрытом режиме
  commission_hidden_mode_sending_type?: PaymentTypes;
  commission_hidden_mode_sending_value?: number; // - значение комиссии
  is_arrival_bonus_enabled?: boolean; // включить/выключить компенсацию за подачу
  arrival_bonus_min_distance?: number; // минимальная подача для начисления компенсации (в метрах)
  arrival_bonus_max_distance?: number; // максимальная подача, для который считаем компенсацию (в метрах). Всё что больше - считается как это значение.
  arrival_bonus_value?: number; // бонус за 1 км
  arrival_bonus_base_value?: number; // базовое значение бонуса
  arrival_bonus_queue_type?: 'all' | 'sending' | 'none' ; // переключатель компенсации для заказов по доезду
  // (all - считать для всех заказов, sending - считать только для заказов по магниту, none - не считать компенсацию для заказов по доезду)
}

export interface Currency {
  value: number;
  type: PaymentTypes;
  isValid?: boolean;
}

export enum PaymentTypes {
  natural = 'natural',
  percent = 'percent'
}

export interface Commission {
  tariff_plan_id?: string;
  is_enabled: boolean;
  requests_quantity?: number;
  type?: string;
  value?: number;
  id?: string;
}



// WEBPACK FOOTER //
// ./src/app/driver-tariffs/tariff.ts